import { CASHBOX_LIST, CASHWARRANT_STATUS, CASHWARRANT_LIST_STOCK, CASHWARRANT_LIST_ORG } from './actionTypes';
import { toast } from 'react-toastify';
import { defaultToast } from 'configuration/notifications';
import { cashWarrantApi } from 'helpers/api/cashWarrant';
import { transferApi } from 'helpers/api/transfer';
import { downloadFileFromBase64 } from 'helpers/utils';
import { Rent } from 'store/transferAct/actions';
import { clientApi } from 'helpers/api/client';
import { Client } from 'store/client/actions';

export const downloadFiles = async (id) => {
  let counter = 0;

  /// Продуем скачать документы раз в 10 секунд
  const timer = setInterval(async () => {
    const { data: file } = await transferApi.getTransferActFiles(id);

    /// Может приходить 204 No Content
    if (file?.file) {
      downloadFileFromBase64(file.name, file.file, file.format);
      clearInterval(timer);
    } else {
      counter++;
    }

    if (counter >= 20) {
      clearInterval(timer);
    }
  }, 5000);
};

export const getDIIAData = async (barcode, history, dispatch, onDuplication) => {
  const toastId = defaultToast('Происходит получение данных с ДІЯ...', { autoClose: false });
  let counter = 0;

  const timer = setInterval(async () => {
    const { data: result } = await clientApi.checkStatusDIIABarcode({ barcode });

    if (result?.id) {
      if (result?.error) {
        toast.update(toastId, {
          render: 'Данные клиента с ДІЯ не получены...',
          type: toast.TYPE.ERROR,
          className: 'error-toast',
          autoClose: 4000,
        });
        clearInterval(timer);
        return;
      }
      toast.update(toastId, {
        render: 'Данные клиента с ДІЯ успешно получены...',
        type: toast.TYPE.SUCCESS,
        className: 'success-toast',
        autoClose: 4000,
      });
      if (result?.duplication) {
        onDuplication(result.id);
        clearInterval(timer);
        return;
      }

      const path = `/client/${result.id}`;
      const currentPath = history.location.pathname;

      if (path === currentPath) {
        dispatch(Client.getClient(result.id));
      } else {
        const historyParams = {};
        if (currentPath === '/rent' || currentPath === '/reservation') {
          historyParams.currentPath = currentPath;
        }
        history.push(path, historyParams);
      }
      clearInterval(timer);
    } else {
      counter++;
    }

    if (counter >= 60) {
      toast.update(toastId, {
        render: 'Ошибка: клиент не отправил данные с ДІЯ.',
        type: toast.TYPE.ERROR,
        className: 'error-toast',
        autoClose: 4000,
      });
      clearInterval(timer);
    }
  }, 3000);
};

export const downloadAgreement = async (id) => {
  const { data } = await transferApi.getAgreementFile(id);

  if (data?.file) {
    downloadFileFromBase64(data.file_name, data.file);
  }
};

export const CashWarrant = {
  getCashBoxes: () => async (dispatch) => {
    return cashWarrantApi.getCashBoxes().then(({ data } = {}) => {
      dispatch(CashWarrant.setCashBoxList(data));
    });
  },
  getCashBoxStock: () => async (dispatch) => {
    return cashWarrantApi.getCashBoxStock().then(({ data } = {}) => {
      dispatch(CashWarrant.setCashBoxListStock(data));
    });
  },
  getCashBoxOrg: () => async (dispatch) => {
    return cashWarrantApi.getCashBoxOrg().then(({ data } = {}) => {
      dispatch(CashWarrant.setCashBoxListOrg(data));
    });
  },

  createTransferActReceiveBoxes: (rentId, rentData, warrantsData) => async (dispatch) => {
    const toastId = defaultToast('Происходит закрытие аренды...', { autoClose: false });

    const { data: rent } = await transferApi.createTransferAct({ ...rentData, parentID1C: rentId });
    if (rent) {
      const { data: warrant } = await cashWarrantApi.createCashWarrant(warrantsData);
      if (warrant) {
        await downloadFiles(rentId);
      }
      dispatch(CashWarrant.setCashWarrantStatus(warrant ? 1 : -1));
    } else {
      dispatch(CashWarrant.setCashWarrantStatus(-1));
    }

    toast.update(toastId, {
      render: 'Акт успешно закрыт. Загрузка файлов начнется через несколько секунд...',
      type: toast.TYPE.SUCCESS,
      className: 'success-toast',
      autoClose: 4000,
    });
  },

  updateTransferActContinueBoxes: (rentId, rentData, warrantsData) => async (dispatch) => {
    const toastId = defaultToast('Происходит продление...', { autoClose: false });

    const { data: rent } = await transferApi.updateTransferAct(rentId, rentData);

    if (rent) {
      const { data: warrant } = await cashWarrantApi.createCashWarrant(warrantsData);

      if (warrant) {
        dispatch(CashWarrant.setCashWarrantStatus(1));
        await downloadFiles(rentId);
        toast.update(toastId, {
          render: 'Акт успешно продлен. Загрузка файлов начнется через несколько секунд...',
          type: toast.TYPE.SUCCESS,
          className: 'success-toast',
          autoClose: 4000,
        });
        return warrant;
      } else {
        dispatch(CashWarrant.setCashWarrantStatus(-1));
      }
    } else {
      dispatch(CashWarrant.setCashWarrantStatus(-1));
    }

    toast.update(toastId, {
      render: 'Акт успешно продлен. Загрузка файлов начнется через несколько секунд...',
      type: toast.TYPE.SUCCESS,
      className: 'success-toast',
      autoClose: 4000,
    });
    return [];
  },

  updateTransferActBoxes: (rentId, rentData, warrantsData) => async (dispatch) => {
    const toastId = defaultToast('Происходит сохранение...', { autoClose: false });
    let showFileDownloadToast = false;

    const { data: rent } = await transferApi.updateTransferAct(rentId, rentData);
    if (rent) {
      const { data: warrant } = await cashWarrantApi.createCashWarrant(warrantsData);

      if (warrant) {
        /// Скачивание документов трансфер акта
        if (rentData.status === 'Ожидает выдачи инструмента' || rentData.status === 'В аренде') {
          showFileDownloadToast = true;

          await downloadFiles(rentId);
          await downloadAgreement(rent.actID1C);
        }

        dispatch(CashWarrant.setCashWarrantStatus(1));
        toast.update(toastId, {
          render: showFileDownloadToast
            ? 'Акт успешно сохранен. Загрузка файлов начнется через несколько секунд...'
            : 'Акт успешно сохранен.',
          type: toast.TYPE.SUCCESS,
          className: 'success-toast',
          autoClose: 4000,
        });
        return warrant;
      } else {
        dispatch(CashWarrant.setCashWarrantStatus(-1));
      }
    } else {
      dispatch(CashWarrant.setCashWarrantStatus(-1));
    }

    toast.update(toastId, {
      render: showFileDownloadToast
        ? 'Акт успешно сохранен. Загрузка файлов начнется через несколько секунд...'
        : 'Акт успешно сохранен.',
      type: toast.TYPE.SUCCESS,
      className: 'success-toast',
      autoClose: 4000,
    });
    return [];
  },

  createTransferActBoxes: (rentData, warrantsData) => async (dispatch) => {
    const toastId = defaultToast('Происходит сохранение...', { autoClose: false });
    let showFileDownloadToast = false;

    const { data: rent } = await transferApi.createTransferAct(rentData);

    if (rent) {
      dispatch(Rent.updateRent(rent));
      const { data: warrant } = await cashWarrantApi.createCashWarrant(
        warrantsData.map((warrant) => ({
          ...warrant,
          actID: rent.actID1C,
        }))
      );

      if (warrant) {
        /// Скачивание документов трансфер акта
        if (rentData.status === 'Ожидает выдачи инструмента' || rentData.status === 'В аренде') {
          showFileDownloadToast = true;

          await downloadFiles(rent.actID1C);
          await downloadAgreement(rent.actID1C);
        }
        dispatch(CashWarrant.setCashWarrantStatus(1));
        toast.update(toastId, {
          render: showFileDownloadToast
            ? 'Акт успешно сохранен. Загрузка файлов начнется через несколько секунд...'
            : 'Акт успешно сохранен.',
          type: toast.TYPE.SUCCESS,
          className: 'success-toast',
          autoClose: 4000,
        });
        return warrant;
      } else {
        dispatch(CashWarrant.setCashWarrantStatus(-1));
      }
    } else {
      dispatch(CashWarrant.setCashWarrantStatus(-1));
    }

    toast.update(toastId, {
      render: showFileDownloadToast
        ? 'Акт успешно сохранен. Загрузка файлов начнется через несколько секунд...'
        : 'Акт успешно сохранен.',
      type: toast.TYPE.SUCCESS,
      className: 'success-toast',
      autoClose: 4000,
    });
    return [];
  },

  setCashWarrantStatus: (payload) => ({
    type: CASHWARRANT_STATUS,
    payload,
  }),

  setCashBoxList: (payload) => ({
    type: CASHBOX_LIST,
    payload,
  }),

  setCashBoxListStock: (payload) => ({
    type: CASHWARRANT_LIST_STOCK,
    payload,
  }),
  setCashBoxListOrg: (payload) => ({
    type: CASHWARRANT_LIST_ORG,
    payload,
  }),
};
